<div #wrapper class="wrapper" style="height: 100%;">
    <div class="modal-header-wrapper">
        <div class="text-wrapper" [class.font-weight-600]="true">{{ 'create_new_profile' | localise }}</div>
        <div class="responsive-flex-wrapper shortcuts">
            <i class="ti-close" (click)="onClose()"></i>
        </div>
    </div>

    <ng-container>
        <div class="modal-body">
            <div class="form-block">
                <form class="pt-3">
                    <div class="form-group">
                        <label class="font-weight-bold">Хранене:</label>

                        <select required="required" (change)="onMealChange($event)" class="form-control">
                            <option value="">- - изберете хранене - -</option>
                            <option
                                    *ngFor="let dailyMeal of dailyMeals"
                                    [selected]="selectedMealId === dailyMeal.id"
                                    [value]="dailyMeal.id">
                                {{ dailyMeal.dailyMeal.title + ' - ' + dailyMeal.title }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label class="font-weight-bold">Процент:</label>

                        <input
                                (change)="onPercentageChange($event)"
                                [value]="overwritePercentage"
                                type="number"
                                step="1"
                                min="0"
                                max="100"
                                class="form-control"
                                placeholder="{{ 'procent_overwrite' | localise }}"/>
                    </div>
                </form>

                <div class="clear"></div>

                <button
                        type="button"
                        class="btn btn-block btn-success filter-btn"
                        (click)="onCreate()">
                    Създай
                </button>
            </div>
        </div>
    </ng-container>
</div>
